import { atom } from 'jotai'


export const typeAtom = atom('経営者')
